import React, { useEffect, useState } from 'react';

function App() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetch("/api/home")
      .then(response => response.json())
      .then(data => setMessage(data.message))
      .catch((error) => console.error("Ошибка при получении данных:", error));
  }, []);

  return (
    <div>
      <h1>{message ? message : 'Loading...'}</h1>
    </div>
  );
}

export default App;
